import React from 'react';
import ErrorPage from 'app/components/misc/ErrorPage';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import AboutContent from 'app/pageContents/AboutContent';
import prismicApi from 'app/api/prismicApi';
import { PAGE_TYPE } from 'app/constants/app';
import { configureStaticPageHead } from 'app/utils/configurePageHead';
import get from 'lodash/get';

const jsonLd = {
  // to convert to a string before passing to <PageHead /> (PageHead expects jsonLd: string).
  '@context': 'http://schema.org',
  '@type': 'LocalBusiness',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Singapore',
    addressRegion: 'Singapore',
    streetAddress: '77 Ayer Rajah Crescent, #03-23, Singapore 139954',
  },
  description:
    "Singapore's largest one-stop platform to help Singaporeans make smarter personal finance decision.",
  name: 'Seedly',
};

const About = ({ doc }) => {
  if (!doc) return <ErrorPage />;

  if (doc) {
    return (
      <Page withBackground>
        <PageHead
          jsonLd={JSON.stringify(jsonLd)}
          {...configureStaticPageHead(PAGE_TYPE.ABOUT)}
        />
        <AboutContent doc={doc} />
      </Page>
    );
  }
};

About.getInitialProps = async ({ res }) => {
  const response = await prismicApi('document.type', 'about');
  const doc = get(response, 'results[0].data');
  if (res && !doc) res.statusCode = 404;
  return { doc };
};

export default About;
